import React, { useEffect, useState } from 'react'
import TextBox from '../Generales/TextBox'



const ComponentListaInputValoresEstablecidos = ({ pregunta, onChange, value }) => {

    const array = []

    const [valores, setValores] = useState({})
    const [filas, setFilas] = useState([])

    useEffect(() => {

        if (pregunta) {
            setFilas(groupByKey(pregunta.cuesOpcionesLista, 'fila'))
        }

    }, [])

    function groupByKey(array, key) {
        return array
            .reduce((hash, obj) => {
                if (obj[key] === undefined) return hash;
                var objectArray = Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })

                var filas = []

                for (const key in objectArray) {
                    filas.push(objectArray[key])
                }
                return filas
            }, {})
    }







    return (
        <div>


            <table className='table table-bordered'>
                {filas && filas.length > 0 && filas.map((fila,indexR) => {
                    return (
                        <tr key={indexR}>
                            {fila.map((opcion, indexC) => {
                                return (
                                    <td key={indexC}>
                                        {opcion.tipo == "texto" &&
                                            <p>{opcion.descripcion}</p>
                                        }

                                        {opcion.tipo == "numero" &&
                                            <TextBox
                                                tabIndex="1"
                                                type={'number'}
                                                value={ value[opcion.id]}
                                                name={opcion.id}
                                                id={opcion.id}
                                                classNameInput={"form-control"}
                                                placeholder={pregunta.cuesPregunta}
                                                onChange={(valor) => {

                                                    var cloneAux = {...value}

                                                    cloneAux[opcion.id] = valor

                                                    onChange(cloneAux)
                                                    //onChange(cloneAux)

                                                }}

                                                required={opcion.required}

                                                esDependiente={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? false : true}
                                                codPadre={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? null : pregunta.cuesPadre}
                                                valorDependiente={(pregunta.cuesPadre == null || pregunta.cuesPadre == '') ? null : pregunta.cuesDepende}
                                                validate={false}
                                                validationCallback={res => {



                                                }}
                                                onBlur={(e) => {

                                                }}
                                                validationOption={{
                                                    type: 'number',

                                                    reg: new RegExp(`^.{1,200}$`), //Optional.[Bool].Default: "" Custom regex.
                                                    msgOnError: ''
                                                }}

                                            />
                                        }
                                    </td>
                                )
                            })}

                        </tr>
                    )
                })}

            </table>





        </div>
    )

}
export default ComponentListaInputValoresEstablecidos